import React, { useState } from "react";
import Slider from "react-slick";
import "./sliderscss.scss";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { PlayCircleOutlined } from "@ant-design/icons";
import SynthesiaVideo from "./SynthesiaVideo";

export default function ImageSlider({ data }) {
  const [activeVideo, setActiveVideo] = useState(null);

  const settings = {
    className: "center",
    centerMode: true,
    infinite: false,
    centerPadding: "60px",
    slidesToShow: 1,
    autoplay: false,
    dots: false,
    arrows: true,
    adaptiveHeight: false,
    beforeChange: () => setActiveVideo(null), // reset video on slide change
  };

  function getVideoId(url) {
    const regExp =
      /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
    const match = url?.match(regExp);
    return match && match[2].length === 11 ? match[2] : null;
  }

  if (data && data.length > 0 && data[0].id) {
    return (
      <div className="custom-slider-container">
        <Slider {...settings}>
          {data?.map((item, i) => {
            // -------- YouTube --------
            if (
              item?.mediaLink?.mediaType === "SOCIAL_MEDIA" &&
              item.mediaLink.url
            ) {
              const videoId = getVideoId(item.mediaLink.url);

              return (
                <div key={i}>
                  <div className="slide">
                    {activeVideo === i ? (
                      <iframe
                        title={`Youtube-${i}`}
                        allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                        allowFullScreen
                        width="100%"
                        height="400"
                        src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
                      />
                    ) : (
                      <div
                        className="video-thumbnail"
                        onClick={() => setActiveVideo(i)}
                        style={{
                          cursor: "pointer",
                          backgroundImage: `url("https://img.youtube.com/vi/${videoId}/hqdefault.jpg")`,
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                          width: "100%",
                          height: "220px",
                        }}
                      >
                        <div className="play-btn">
                          <PlayCircleOutlined />
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="video-title">{item?.title}</div>
                </div>
              );
            }

            // -------- Vimeo --------
            if (
              item?.mediaLink?.mediaType === "VIMEO_MEDIA" &&
              item.mediaLink.url
            ) {
              const vimeoId = item.mediaLink.url.split("/").pop();

              return (
                <div key={i}>
                  <div className="slide">
                    {activeVideo === i ? (
                      <iframe
                        title={`Vimeo-${i}`}
                        src={`${item.mediaLink.url}?autoplay=1`}
                        allow="autoplay; fullscreen; picture-in-picture"
                        allowFullScreen
                        width="100%"
                        height="400"
                      />
                    ) : (
                      <div
                        className="video-thumbnail"
                        onClick={() => setActiveVideo(i)}
                        style={{
                          cursor: "pointer",
                          backgroundImage: `url("https://vumbnail.com/${vimeoId}.jpg")`,
                          backgroundSize: "cover",
                          backgroundPosition: "center",
                          width: "100%",
                          height: "220px",
                        }}
                      >
                        <div className="play-btn">
                          <PlayCircleOutlined />
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="video-title">{item?.title}</div>
                </div>
              );
            }

            if (
              item?.mediaLink?.mediaType === "SYNTHESIA_MEDIA" &&
              item.mediaLink.url
            ) {
              console.log('console added for testing')
              const rawUrl = item?.mediaLink?.url;

              if (!rawUrl) return null;

              const uuidMatch = rawUrl.match(
                /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/
              );

              if (!uuidMatch) return null;

              const videoId = uuidMatch[0];
              const embedUrl = `https://share.synthesia.io/embeds/videos/${videoId}`;

              return (
                <div key={i}>
                  <div className="slide">
                    <div
                      style={{
                        width: "100%",
                        height: "220px",          // SAME HEIGHT AS OTHER VIDEOS
                        overflow: "hidden",
                        borderRadius: "6px",
                      }}
                    >
                      <iframe
                        src={embedUrl}
                        title={item?.mediaLink?.title}
                        allow="autoplay; encrypted-media"
                        allowFullScreen
                        frameBorder="0"
                        style={{
                          width: "100%",
                          height: "100%",  // fill container
                        }}
                      />
                    </div>
                  </div>

                  <div className="video-title">{item?.title}</div>
                </div>
              );
            }


            // -------- Default Image --------
            return (
              <div key={i}>
                <div className="slide">
                  <div className="img-slide">
                    <img
                      src={item?.mediaLink?.url}
                      alt=""
                      className="c1 carousel-image"
                      style={{
                        backgroundColor: "white",
                        border: "1px solid gray",
                      }}
                    />
                  </div>
                </div>
                <div className="video-title">{item?.title}</div>
              </div>
            );


          })}
        </Slider>
      </div>
    );
  } else {
    return <></>;
  }
}
